<div class="empty-state-wrap order-success-wrap">
  <div class="empty-state-card order-success-card">

    <div class="empty-state-icon order-success-icon">
      <img class="empty-state-img" src="/assets/orderstatus.png" alt="order completed" />
    </div>

    <h2 class="empty-state-title">
      {{ "order completed" | transloco }}
    </h2>

    <p class="empty-state-subtitle">
      {{ "order completed hint" | transloco }}
    </p>

    <button class="empty-state-btn" routerLink="/Myorders">
      {{ "myorders" | transloco }}
    </button>
  </div>
</div>